import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/core/auth/AuthContext';
import { brandConfig } from '@/config/brand.config';
import { InternalLoginForm } from './components/InternalLoginForm';

export default function InternalLoginPage() {
  const { isAuthenticated, isLoading, authError } = useAuth();
  const location = useLocation();
  const from = (location.state as { from?: { pathname: string } })?.from?.pathname ?? '/';

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <div className="flex flex-col items-center gap-4">
          <i className="ri-loader-4-line animate-spin text-brand-600 text-3xl" />
          <p className="text-xs font-bold text-slate-400  tracking-widest">Đang xác thực...</p>
        </div>
      </div>
    );
  }

  // Redirect if logged in
  if (isAuthenticated && !authError) {
    const dest = from && from !== '/auth/login' && from !== '/auth/internal-login' ? from : '/';
    return <Navigate to={dest} replace />;
  }

  return (
    <div className="min-h-screen w-full flex items-center justify-center bg-slate-50 relative overflow-hidden">

      <div className="w-full max-w-[420px] px-6 relative z-10">
        {/* Simplified Login Card */}
        <div className="bg-white/80 backdrop-blur-xl rounded-[2.5rem] border border-white p-10 shadow-2xl shadow-slate-200/60">
          <div className="mb-8 text-center">
            <h2 className="text-xl font-bold text-slate-900">Đăng nhập Quản trị</h2>
            <p className="text-sm text-slate-500 mt-1">Truy cập vào bảng điều khiển hệ thống</p>
          </div>

          <InternalLoginForm />
        </div>


      </div>
    </div>
  );
}
